import {
    consignorGroup,
    getAddUserBranch,
    getAllAccount,
    getDashbordData,
    getRole,
    getUserAccount,
    handleKeyDown,
    vehicleGroup,
  } from "_services";
  import {
    ButtonHeading,
    CommonInput,
    CustomSelect,
    Customdropdown,
  } from "components";
  import { addUser, editUser, getUserDetail } from "features";
  import { errorSchema, utils } from "helper";
  import useDocumentTitle from "hooks/useDocumentTitle";
  import Loading from "pages/Loading";
  import React, { useCallback, useEffect, useState } from "react";
  import toast from "react-hot-toast";
  import { useDispatch, useSelector } from "react-redux";
  import { useLocation, useNavigate, useParams } from "react-router-dom";
  import StorageService from "utils/StorageServices/StorageServices";
  
  const AddUserSetting = (props) => {
    useDocumentTitle("User | T360");
  const {setActiveTab} = props
    const initial = {
      company_user_name: "",
      mobileno: "",
      email_id: "",
      role_id: "",
      branch_list: [],
      language: "eg",
      company_id: StorageService.getCompanyId(),
      consignor_group_id: "",
      vehicle_group_id: "",
      web_or_mobile: 0,
      trip_payment_approval: 0,
      expenses_approval: 0,
    };
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const disableFields = location?.state?.disableFields;
    const [formValue, setFormValue] = useState(initial);
    const [formError, setFormError] = useState("");
    const [consignorGroupList, setConsignorGroupList] = useState([]);
    const [vehicleGroupList, setVehicleGroupList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [isCheck, setIsCheck] = useState([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [disabled, setDisabled] = useState(false);
    // const [allAccount, setAllAccount] = useState([]);
    const [userAccount, setUserAccount] = useState([]);
    const [modifyAccount, setModifyAccount] = useState([]);
    const [allCheckbox, setAllCheckbox] = useState(false);
    const [filterAccountList, setFilterAccountList] = useState([]);
    const [userDetais, setUserDetais] = useState([]);
    const [addTransaction, setAddTransaction] = useState({
      approval_required: 0,
      submit_access: 0,
    });
  
    const [partyFreight, setPartyFreight] = useState({
      can_view_freight: 0,
      can_edit_freight: 0,
      add_total_freight: 0,
      add_advance_freight: 0,
      add_balance: 0,
      add_claim_receivable: 0,
      add_claim_payable: 0,
    });
  
    const [supplierFreight, setSupplierFreight] = useState({
      add_total_freight: 0,
      add_advance_freight: 0,
      add_balance: 0,
      add_claim_receivable: 0,
      add_claim_payable: 0,
    });
  
    const [other, setOther] = useState({
      add_other_expenses: 0,
      add_other_receipt: 0,
    });
  
    const [paymentAprrove, setPaymentAprrove] = useState({
      pending: 0,
      approve: 0,
      hold: 0,
      complete: 0,
      cancel: 0,
    });
  
    const [contractSetting, setContractSetting] = useState({
      show_amount: 0,
      edit_amount: 0,
    });
  
    const [consignorView, setConsignorView] = useState({
      restricted_view: 0,
    });
  
    const [suplierView, setSuplierView] = useState({
      restricted_view: 0,
    });
  
    const [selectAll, setSelectAll] = useState({
      add_transaction: 0,
      party_freight: 0,
      supplier_freight: 0,
      other_freight: 0,
      payment_approval: 0,
    });
  
    const checkAnyTrue = (state) => {
      return Object.values(state).some((value) => value === 1);
    };
  
    const transactionCheck = checkAnyTrue(addTransaction);
    const partyCheck = checkAnyTrue(partyFreight);
    const supplierCheck = checkAnyTrue(supplierFreight);
    const otherCheck = checkAnyTrue(other);
    const paymentCheck = checkAnyTrue(paymentAprrove);
    const contractCheck = checkAnyTrue(contractSetting);
  
    useEffect(() => {
      getConsignorGroupList();
      getVehicleGroupList();
      getRoleList();
      // getAccountHandle();
      if (!id) {
        getUserAccountHandle();
        getBranchList();
      } else {
        getUserDetaisHandle(id);
      }
    }, [id]);
  
    useEffect(() => {
      let array = [];
      // let newArray = userAccount?.sub_category?.map((item, index) =>
      //   item?.accounts.map((item2, index) => {
      //     array.push({
      //       ...item2,
      //       category_id: userAccount?.id,
      //       category_name: userAccount?.name,
      //       sub_category_name: item?.name,
      //       sub_category_id: item?.id,
      //       account_id: item2?.id,
      //       account_name: item2?.name,
      //       account_code: item2?.code,
      //       isSelected: 0,
      //       selection: 0,
      //       view_balance: 0,
      //       edit_account: 0,
      //       delete_account: 0,
      //       // view_transaction: 0,
      //       // edit_transaction: 0,
      //       // delete_transaction: 0,
      //     });
      //   })
      // );
  
      let newArray = userAccount?.map((item, index) => {
        array.push({
          ...item,
          category_id: item?.category_id,
          category_name: item?.sub_category_name,
          sub_category_name: item?.sub_category_name,
          sub_category_id: item?.sub_category_id,
          account_id: item?.account_id,
          account_name: item?.account_name,
          account_code: item?.code,
          selection:
            item?.create &&
            item?.view &&
            item?.edit &&
            item?.delete
              ? 1
              : 0,
          create: item?.create,
          view: item?.view,
          edit: item?.edit,
          delete: item?.delete,
        });
      });
  
      setModifyAccount(array);
    }, [userAccount]);
  
    useEffect(()=>{
  if(consignorGroupList && vehicleGroupList && roleList && !id){
    setFormValue({ ...formValue, vehicle_group_id: vehicleGroupList[0]?.value,consignor_group_id:consignorGroupList[0]?.value });
  }
    },[vehicleGroupList,consignorGroupList,roleList])
  
    const memoizedSetSelectAll = useCallback(setSelectAll, []);
  
    useSelectAll(addTransaction, "add_transaction", memoizedSetSelectAll);
    useSelectAll(partyFreight, "party_freight", memoizedSetSelectAll);
    useSelectAll(supplierFreight, "supplier_freight", memoizedSetSelectAll);
    useSelectAll(other, "other_freight", memoizedSetSelectAll);
    useSelectAll(paymentAprrove, "payment_approval", memoizedSetSelectAll);
  
    const getConsignorGroupList = async () => {
      try {
        let object = {
          company_id: StorageService.getCompanyId(),
          limit: 100,
          offset: 1,
          search: "",
          status: 1,
        };
        const res = await consignorGroup(object);
        if (res?.responseCode == 200) {
          const resList = res?.data.map((i) => {
            return {
              label: i?.name,
              value: i?._id,
            };
          });
  
          setConsignorGroupList(resList);
          // setFormValue({ ...formValue, consignor_group_id: resList[0].value });
        } else {
          toast.error(res?.responseMessage);
        }
      } catch (error) {
        // throw error;
      }
    };
    const getVehicleGroupList = async () => {
      try {
        let object = {
          company_id: StorageService.getCompanyId(),
          limit: 2000,
          offset: 1,
          search: "",
          status: 1,
        };
        const res = await vehicleGroup(object);
        if (res?.responseCode == 200) {
          const resList = res?.data.vehicle_group_list?.map((i) => {
            return {
              label: i?.name,
              value: i?._id,
            };
          });
  
          setVehicleGroupList(resList);
          // setFormValue({ ...formValue, vehicle_group_id: resList[0]?.value });
        } else {
          toast.error(res?.responseMessage);
        }
      } catch (error) {
        // throw error;
      }
    };
    const getBranchList = async () => {
      // const res = await getDashbordData({
      //   company_id: StorageService.getCompanyId(),
      //   select_company_id: 1,
      // });
      const res = await getAddUserBranch({
        company_id: StorageService.getCompanyId(),
      });
  
      if (res?.responseCode === 200) {
        setBranchList(res?.data?.branch_list);
      } else {
        toast.error(res?.responseMessage);
      }
    };
  
    const getRoleList = async () => {
      const res = await getRole({
        company_id: StorageService.getCompanyId(),
      });
  
      if (res?.responseCode === 200) {
        setRoleList(
          res?.data?.roleDetail?.map((i) => {
            return {
              label: i?.role_name,
              value: i?._id,
            };
          })
        );
      } else {
        toast.error(res?.responseMessage);
      }
    };
  
    // const getAccountHandle = async () => {
    //   try {
    //     const resp = await getAllAccount({
    //       company_id: StorageService.getCompanyId(),
    //     });
    //     setAllAccount(resp);
    //   } catch (error) {
    //     // throw error;
    //   }
    // };
  
    const getUserAccountHandle = async () => {
      try {
        const resp = await getUserAccount({
          company_id: StorageService.getCompanyId(),
          category_id: 1,
        });
  
        if (resp?.responseCode === 200) {
          setUserAccount(resp?.data?.account_list);
        }
      } catch (error) {
        // throw error;
      }
    };
  
    const getUserDetaisHandle = async (id) => {
      try {
        const resp = await getUserDetail({
          company_id: StorageService.getCompanyId(),
          param_user_id: id,
        });
  
        if (resp?.responseCode === 200) {
          setFormValue({
            ...formValue,
            company_user_name: resp?.data?.user?.company_user_name,
            mobileno: resp?.data?.user?.user_id?.mobile_no,
            email_id: resp?.data?.user?.email_id,
            role_id: resp?.data?.user?.role_id?._id,
            web_or_mobile: resp?.data?.user?.web_or_mobile,
            consignor_group_id: resp?.data?.user?.consignor_group_id?._id,
            vehicle_group_id: resp?.data?.user?.vehicle_group_id?._id,
            expenses_approval:resp?.data?.user?.expenses_approval,
            trip_payment_approval:resp?.data?.user?.trip_payment_approval
          });
          setUserDetais(resp?.data?.user);
          setBranchList(resp?.data?.user?.branch_list);
          setUserAccount(resp?.data?.user?.account_list);
          setAddTransaction(resp?.data?.user?.adding_transaction);
          setPartyFreight(resp?.data?.user?.party_freight);
          setSupplierFreight(resp?.data?.user?.supplier_freight);
          setOther(resp?.data?.user?.other);
          setPaymentAprrove(resp?.data?.user?.payment_approval);
          setConsignorView(resp?.data?.user?.consignor_view);
          setSuplierView(resp?.data?.user?.supplier_view);
          setContractSetting(resp?.data?.user?.contract);
        }
      } catch (error) {
        // throw error;
      }
    };
  
  
  
    const onHandleAll = async (name, checked, label) => {
      if (label === "addTransaction") {
        const updatedFreight = Object.keys(addTransaction).reduce((acc, key) => {
          acc[key] = checked ? 1 : 0;
          return acc;
        }, {});
        setAddTransaction(updatedFreight);
        setSelectAll({ ...selectAll, add_transaction: checked ? 1 : 0 });
      }
      if (label === "party") {
        const updatedFreight = Object.keys(partyFreight).reduce((acc, key) => {
          acc[key] = checked ? 1 : 0;
          return acc;
        }, {});
        setPartyFreight(updatedFreight);
        setSelectAll({ ...selectAll, party_freight: checked ? 1 : 0 });
      }
      if (label === "supplier") {
        const updatedFreight = Object.keys(supplierFreight).reduce((acc, key) => {
          acc[key] = checked ? 1 : 0;
          return acc;
        }, {});
        setSupplierFreight(updatedFreight);
        setSelectAll({ ...selectAll, supplier_freight: checked ? 1 : 0 });
      }
      if (label === "paymentAprrove") {
        const updatedFreight = Object.keys(paymentAprrove).reduce((acc, key) => {
          acc[key] = checked ? 1 : 0;
          return acc;
        }, {});
        setPaymentAprrove(updatedFreight);
        setSelectAll({ ...selectAll, payment_approval: checked ? 1 : 0 });
      }
      if (label === "other") {
        const updatedFreight = Object.keys(other).reduce((acc, key) => {
          acc[key] = checked ? 1 : 0;
          return acc;
        }, {});
        setOther(updatedFreight);
        setSelectAll({ ...selectAll, other_freight: checked ? 1 : 0 });
      }
    };
  
    const onHandleChange = async (name, checked, label) => {
      if (label === "addTransaction") {
        if (checked) {
          setAddTransaction({ ...addTransaction, [name]: 1 });
        } else {
          setAddTransaction({ ...addTransaction, [name]: 0 });
        }
      }
  
      if (label === "party") {
        if (checked) {
          setPartyFreight({ ...partyFreight, [name]: 1 });
        } else {
          setPartyFreight({ ...partyFreight, [name]: 0 });
        }
      }
  
      if (label === "supplier") {
        if (checked) {
          setSupplierFreight({ ...supplierFreight, [name]: 1 });
        } else {
          setSupplierFreight({ ...supplierFreight, [name]: 0 });
        }
      }
  
      if (label === "paymentAprrove") {
        if (checked) {
          setPaymentAprrove({ ...paymentAprrove, [name]: 1 });
        } else {
          setPaymentAprrove({ ...paymentAprrove, [name]: 0 });
        }
      }
      if (label === "other") {
        if (checked) {
          setOther({ ...other, [name]: 1 });
        } else {
          setOther({ ...other, [name]: 0 });
        }
      }
      if (label === "consignorView") {
        if (checked) {
          setConsignorView({ ...consignorView, [name]: 1 });
        } else {
          setConsignorView({ ...consignorView, [name]: 0 });
        }
      }
      if (label === "supplierView") {
        if (checked) {
          setSuplierView({ ...suplierView, [name]: 1 });
        } else {
          setSuplierView({ ...suplierView, [name]: 0 });
        }
      }
  
      if (label === "contractSetting") {
        if (checked) {
          setContractSetting({ ...contractSetting, [name]: 1 });
        } else {
          if (name === "show_amount") {
            setContractSetting({
              ...contractSetting,
              edit_amount: 0,
              show_amount: 0,
            });
          } else {
            setContractSetting({ ...contractSetting, [name]: 0 });
          }
        }
      }
    };
  
    const handleOnChange = async (name, value) => {
      const stateObj = {
        ...formValue,
        [name]:
          name === "role_id" ||
          name === "consignor_group_id" ||
          name === "vehicle_group_id"
            ? value.value
            : value,
      };
  
      setFormValue(stateObj);
  
      if (!!formError) {
        const validationResult = await utils.checkFormError(
          formValue,
          errorSchema.addUserSchema
        );
        if (validationResult === true) {
          setFormError("");
        } else {
          setFormError(validationResult);
        }
      }
    };
  
    const handleCheckboxChange = (id) => {
      setBranchList(
        branchList.map((branch) =>
          branch._id === id
            ? { ...branch, selection: branch.selection ? 0 : 1 }
            : branch
        )
      );
    };
  
    const handleSelectAll = (event) => {
      const isChecked = event.target.checked;
      setBranchList(
        branchList.map((branch) => ({ ...branch, selection: isChecked ? 1 : 0 }))
      );
    };
  
    const selectedBranchIds = branchList
      .filter((branch) => branch.selection === 1)
      .map((branch) => branch._id);
  
    const hasFullAccess = (account) => {
      const permissions = ["selection", "create", "view", "edit", "delete"];
  
      return permissions.every((permission) => account[permission] === 1);
    };
  
    useEffect(() => {
      const filteredAccounts = disableFields
        ? modifyAccount.filter(
            (account) =>
              account.selection === 1 ||
              account.create === 1 ||
              account.view === 1 ||
              account.edit === 1 ||
              account.delete === 1
          )
        : modifyAccount;
  
      // Check if all filtered accounts have full access
      const allAccountsHaveFullAccess = filteredAccounts.every(hasFullAccess);
  
      // Set the state for the "allCheckbox"
      setAllCheckbox(allAccountsHaveFullAccess);
  
      const filteredAccount = modifyAccount
        .filter((item) => item.view === 1)
        .map((item) => ({
          category_id: item?.category_id,
          sub_category_id: item?.sub_category_id,
          account_id: item?.account_id,
          selection: item?.selection,
          create: item?.create,
          view: item?.view,
          edit: item?.edit,
          delete: item?.delete,
        }));
  
      setFilterAccountList(filteredAccount);
    }, [modifyAccount]);
  
    const onSubmit = async (e, action) => {
      e.preventDefault();
      const validationResult = await utils.checkFormError(
        { ...formValue },
        errorSchema.addUserSchema
      );
  
      const payloadData = {
        company_user_name: formValue?.company_user_name,
        mobileno: formValue?.mobileno,
        email_id: formValue?.email_id,
        role_id: formValue?.role_id,
        branch_list: selectedBranchIds,
        language: formValue?.language,
        company_id: formValue?.company_id,
        consignor_group_id: formValue?.consignor_group_id,
        vehicle_group_id: formValue?.vehicle_group_id,
        web_or_mobile: formValue?.web_or_mobile,
        account_list: filterAccountList ? filterAccountList : [],
        // adding_transaction: addTransaction,
        // party_freight: partyFreight,
        // supplier_freight: supplierFreight,
        // other: other,
        // payment_approval: paymentAprrove,
        // consignor_view: consignorView,
        // supplier_view: suplierView,
        trip_payment_approval: formValue?.trip_payment_approval,
        expenses_approval: formValue?.expenses_approval,
        contract: contractSetting,
      };
  
      if (validationResult === true) {
        try {
          setDisabled(true);
          const res = await dispatch(
            !id
              ? addUser(payloadData)
              : editUser({ ...payloadData, param_user_id: id })
          );
          if (res?.payload?.responseCode === 200) {
            toast.success(res?.payload?.responseMessage);
            if (action === "add") {
            //   navigate("/setting/user");
            setActiveTab("Users")
              setDisabled(false);
              clearAll();
            } else {
              clearAll();
              setDisabled(false);
            }
          } else {
            toast.error(res?.payload?.responseMessage);
            setDisabled(false);
          }
        } catch (error) {
          setDisabled(false);
          // throw error;
        }
      } else {
        setFormError(validationResult);
      }
    };
  
    const clearAll = () => {
      setFormValue(initial);
      modifyAccount?.map((i, index) => {
        let newData = [...modifyAccount];
  
        setAllCheckbox(false);
        newData[index].isSelected = 0;
        newData[index].selection = 0;
        newData[index].view_balance = 0;
        newData[index].edit_account = 0;
        newData[index].delete_account = 0;
  
        setModifyAccount(newData);
      });
      setBranchList(branchList.map((branch) => ({ ...branch, selection: 0 })));
      setPartyFreight({
        can_view_freight: 0,
        can_edit_freight: 0,
        add_total_freight: 0,
        add_advance_freight: 0,
        add_balance: 0,
        add_claim_receivable: 0,
        add_claim_payable: 0,
      });
      setAddTransaction({
        approval_required: 0,
        submit_access: 0,
      });
      setPartyFreight({
        can_view_freight: 0,
        can_edit_freight: 0,
        add_total_freight: 0,
        add_advance_freight: 0,
        add_balance: 0,
        add_claim_receivable: 0,
        add_claim_payable: 0,
      });
  
      setSupplierFreight({
        add_total_freight: 0,
        add_advance_freight: 0,
        add_balance: 0,
        add_claim_receivable: 0,
        add_claim_payable: 0,
      });
  
      setOther({
        add_other_expenses: 0,
        add_other_receipt: 0,
      });
  
      setPaymentAprrove({
        pending: 0,
        approve: 0,
        hold: 0,
        complete: 0,
        cancel: 0,
      });
  
      setConsignorView({
        restricted_view: 0,
      });
      setSuplierView({
        restricted_view: 0,
      });
  
      setContractSetting({
        show_amount: 0,
        edit_amount: 0,
      });
  
      setSelectAll({
        add_transaction: 0,
        party_freight: 0,
        supplier_freight: 0,
        other_freight: 0,
        payment_approval: 0,
      });
    };
  
    const handleCheckboxChangeForAccount = (
      subCategoryId,
      accountId,
      field,
      value
    ) => {
      setModifyAccount((prevData) =>
        prevData.map((account) => {
          if (
            account.sub_category_id === subCategoryId &&
            account.account_id === accountId
          ) {
            let updatedAccount = { ...account, [field]: value };
            if (
              (updatedAccount.create === 1 ||
                updatedAccount.edit === 1 ||
                updatedAccount.delete === 1) &&
              field !== "view" // Only handle this if the field is not View
            ) {
              updatedAccount.view = 1; // Check View
            } else {
              updatedAccount.view = 0;
            }
  
            // If the View checkbox is checked manually, leave it as is
            if (field === "view") {
              updatedAccount.view = value;
            }
  
            // Disable View if any of Create, Delete, or Edit is checked
            const disableView =
              updatedAccount.create === 1 ||
              updatedAccount.edit === 1 ||
              updatedAccount.delete === 1;
            // If any of the fields (view, create, edit, delete) are unchecked, uncheck selection
            if (["view", "create", "edit", "delete"].includes(field) && !value) {
              updatedAccount.selection = 0;
            }
  
            // If selection is checked, set all fields (view, create, edit, delete) to 1
            if (field === "selection") {
              updatedAccount = {
                ...updatedAccount,
                view: value,
                create: value,
                edit: value,
                delete: value,
              };
            }
  
            // Check if all fields (view, create, edit, delete) are checked
            if (
              updatedAccount.view === 1 &&
              updatedAccount.create === 1 &&
              updatedAccount.edit === 1 &&
              updatedAccount.delete === 1
            ) {
              updatedAccount.selection = 1;
            }
  
            return updatedAccount;
          }
          return account;
        })
      );
    };
  
    const handleAccountAccessToggle = (e) => {
      const isChecked = e.target.checked;
      setModifyAccount((prevData) =>
        prevData.map((account) => ({
          ...account,
          selection: isChecked ? 1 : 0,
          view: isChecked ? 1 : 0,
          create: isChecked ? 1 : 0,
          edit: isChecked ? 1 : 0,
          delete: isChecked ? 1 : 0,
        }))
      );
    };
  
    const isAllChecked = modifyAccount.every(
      (account) => account.selection === 1
    );
  
    return (
      <div>
        <ButtonHeading
          title={
            disableFields === true ? "View User" : id ? "Edit User" : "Add User"
          }
          buttonTitle={"Add User"}
          backButtonTitle={disableFields === true && 'Back'}
          backButtonClickHandler={() => disableFields === true && navigate(-1)}
          section="settings"
        />
        {branchList?.length > 0 ? (
          <div>
            <div className="_addContainer">
              <div className="_allUrs_bx">
                <div className="_addRl_bx">
                  <div className="_addRlHead">User Details</div>
  
                  <div className="_addRl_tableBx">
                    <div className="_usrDetails">
                      <div className="pr_procssBx_grid">
                        <div className="_tierDivs">
                          <CommonInput
                            type="text"
                            placeholder="User Name*"
                            label="User Name*"
                            name="company_user_name"
                            disabled={disableFields}
                            value={
                              formValue?.company_user_name
                                ? formValue?.company_user_name
                                : ""
                            }
                            focus={!!formError?.company_user_name}
                            error={formError?.company_user_name}
                            onChange={({ target: { name, value } }) =>
                              handleOnChange(name, value)
                            }
                          />
                        </div>
  
                        <div className="_tierDivs">
                          <CommonInput
                            type="text"
                            placeholder="Mobile Number*"
                            label="Mobile Number*"
                            name="mobileno"
                            // onKeyDown={handleKeyDown}
                            maxLength="16"
                            disabled={id || disableFields}
                            value={formValue?.mobileno ? formValue?.mobileno : ""}
                            focus={!!formError?.mobileno}
                            error={formError.mobileno}
                            onChange={({ target: { name, value } }) => {
                              // Remove all non-digit characters (anything that's not 0-9)
                              let cleanedValue = value.replace(/\D/g, '');
                          
                              // Remove '91' or '+91' from start if present and extra digits exist
                              if (cleanedValue.startsWith('91') && cleanedValue.length > 10) {
                                  cleanedValue = cleanedValue.substring(2);
                              }
                          
                              // Allow only if the result is 10 digits or fewer
                              if (/^\d{0,10}$/.test(cleanedValue)) {
                                  handleOnChange(name, cleanedValue);
                              }
                          }}
                            
                          />
                        </div>
  
                        <div className="_tierDivs">
                          <CommonInput
                            type="text"
                            placeholder="Email ID"
                            label="Email ID"
                            name="email_id"
                            disabled={disableFields}
                            value={formValue?.email_id ? formValue?.email_id : ""}
                            focus={!!formError?.email_id}
                            error={formError.email_id}
                            onChange={({ target: { name, value } }) =>
                              handleOnChange(name, value)
                            }
                            
                          />
                        </div>
  
                        <div className="_tierDivs">
                          {/* <Customdropdown /> */}
                          <CustomSelect
                            options={roleList?.filter(
                              (i) => i?.label !== "Owner"
                            )}
                            label="Role"
                            name="role_id"
                            id="role_id"
                            disabled={disableFields}
                            value={
                              formValue.role_id
                                ? roleList?.find(
                                    (i) => i?.value === formValue.role_id
                                  )
                                : { label: "", value: "" }
                            }
                            onSelect={(data) => handleOnChange("role_id", data)}
                            placeholder="Select a Role"
                            error={formError.role_id}
                          />
                        </div>
  
                        <div className="_tierDivs">
                          {/* <Customdropdown /> */}
                          <CustomSelect
                            options={consignorGroupList}
                            // value={consignorGroupList[0]}
                            value={
                              formValue.consignor_group_id
                                ? consignorGroupList?.find(
                                    (i) =>
                                      i?.value === formValue.consignor_group_id
                                  )
                                : { label: "", value: "" }
                            }
                            label="Consignor Group"
                            name="consignor_group_id"
                            disabled={disableFields}
                            onSelect={(data) =>
                              handleOnChange("consignor_group_id", data)
                            }
                            id="consignor_group_id"
                            placeholder="Select Consignor Group"
                            error={formError.consignor_group_id}
                          />
                        </div>
  
                        <div className="_tierDivs">
                          {/* <Customdropdown /> */}
                          <CustomSelect
                            options={vehicleGroupList}
                            label="Vehicle Group"
                            name="vehicle_group_id"
                            disabled={disableFields}
                            // value={vehicleGroupList[0]}
                            value={
                              formValue.vehicle_group_id
                                ? vehicleGroupList?.find(
                                    (i) => i?.value === formValue.vehicle_group_id
                                  )
                                : { label: "", value: "" }
                            }
                            onSelect={(data) =>
                              handleOnChange("vehicle_group_id", data)
                            }
                            id="vehicle_group_id"
                            placeholder="Select Vehicle Group"
                            error={formError.vehicle_group_id}
                          />
                        </div>
                      </div>
                    </div>
  
                    <div className="checkBx_lv ">
                      <input
                        className="form-check-input _avPointer"
                        id="0pay_type1"
                        type="radio"
                        name="web_or_mobile"
                        value={0}
                        disabled={disableFields}
                        checked={formValue?.web_or_mobile == 0}
                        autoComplete="off"
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, value)
                        }
                      />
                      <label
                        htmlFor="0pay_type1"
                        className="form-check-label _avPointer"
                      >
                        All
                      </label>{" "}
                      &nbsp;
                      <input
                        className="form-check-input _avPointer"
                        id="1pay_type2"
                        type="radio"
                        name="web_or_mobile"
                        value={1}
                        disabled={disableFields}
                        checked={formValue?.web_or_mobile == 1}
                        autoComplete="off"
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, value)
                        }
                      />
                      <label
                        htmlFor="1pay_type2"
                        className="form-check-label _avPointer"
                      >
                        Web Access
                      </label>{" "}
                      &nbsp;
                      <input
                        className="form-check-input _avPointer"
                        id="1pay_type3"
                        type="radio"
                        name="web_or_mobile"
                        value={2}
                        disabled={disableFields}
                        checked={formValue?.web_or_mobile == 2}
                        autoComplete="off"
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, value)
                        }
                      />
                      <label
                        htmlFor="1pay_type3"
                        className="form-check-label _avPointer"
                      >
                        Mobile Access
                      </label>{" "}
                      &nbsp;
                    </div>
                  </div>
                </div>
  
                <div className="_mainRl_table">
                  <div className="_addRl_headCheck">
                    <Checkbox
                      type="checkbox"
                      name="Branch Access"
                      id="selectAll"
                      isDisabled={disableFields}
                      handleClick={handleSelectAll}
                      isChecked={branchList.every(
                        (branch) => branch.selection === 1
                      )}
                    />
                  </div>
  
                  <div className="_addRl_checkList">
                    <div className="_brxFlex">
                      {branchList &&
                        branchList.map((i, index) => {
                          return (
                            <div className="_dLass" key={`${i?._id}_${index}`}>
                              <Checkbox
                                className="checkbox_2"
                                index={index}
                                type="checkbox"
                                name={i?.branch}
                                isDisabled={disableFields}
                                id={i._id}
                                handleClick={() => handleCheckboxChange(i._id)}
                                isChecked={i?.selection === 1}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
  
  
                <div className="_mainRl_table __nWd_table">
                  <div className="_addRl_headCheck">
                    <input
                      id="accountAccess"
                      type="checkbox"
                      onChange={handleAccountAccessToggle}
                      checked={isAllChecked}
                      disabled={disableFields}
                    />
                    <label htmlFor="accountAccess" className="anvLabel">
                      <p className="anvLabel">Account Access</p>
                    </label>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Accounts</th>
                        <th>Full Access</th>
                        <th>View</th>
                        <th>Create</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {modifyAccount.map((account) => (
                        <tr
                          key={`_${account.sub_category_id}_${account.account_id}`}
                        >
                          <td>
                            <div className="__blkFx_bx">
                              <p>{account.account_name}</p>{" "}
                              <span className={`__spn${account.category_name}`}>
                                {account.category_name}
                              </span>
                            </div>
                          </td>
                          {[
                            "selection",
                            "view",
                            "create",
                            "edit",
                            "delete"
                          ].map((field) => (
                            <td key={field}>
                              <div className="__withOutlb">
                                <input
                                  type="checkbox"
                                  id={`${field}_${account.sub_category_id}_${account.account_id}`}
                                  checked={!!account[field]}
                                  onChange={(e) =>
                                    handleCheckboxChangeForAccount(
                                      account.sub_category_id,
                                      account.account_id,
                                      field,
                                      e.target.checked ? 1 : 0
                                    )
                                  }
                                  disabled={
                                    field === "view" &&
                                    (account.create === 1 ||
                                      account.edit === 1 ||
                                      account.delete === 1) ||disableFields
                                  }
                                />
                                <label
                                  htmlFor={`${field}_${account.sub_category_id}_${account.account_id}`}
                                  className="anvLable"
                                >
                                  <span>{field}</span>
                                </label>
                              </div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
  
                <div className="_addRl_bx">
                  <div className="_addRlHead">Transaction Permission</div>
  
                  <div className="_addRl_tableBx">
                    <div className="___tpPern_fx">
                      <p>Trip Payment Approval</p>
                      <div className="checkBx_lv">
                        <input
                          className="form-check-input _avPointer"
                          id="0tpa_type1"
                          type="radio"
                          name="trip_payment_approval"
                          value={1} // Set value to 0
                          checked={formValue?.trip_payment_approval === 1} // Check if value is 0
                          autoComplete="off"
                          onChange={
                            ({ target: { name, value } }) =>
                              handleOnChange(name, parseInt(value, 10)) // Pass 0 as an integer
                          }
                          disabled={disableFields}
                        />
                        <label
                          htmlFor="0tpa_type1"
                          className="form-check-label _avPointer"
                        >
                          Required
                        </label>{" "}
                        &nbsp;
                        <input
                          className="form-check-input _avPointer"
                          id="1tpa_type2"
                          type="radio"
                          name="trip_payment_approval"
                          value={0} // Set value to 1
                          checked={formValue?.trip_payment_approval === 0} // Check if value is 1
                          autoComplete="off"
                          onChange={
                            ({ target: { name, value } }) =>
                              handleOnChange(name, parseInt(value, 10)) // Pass 1 as an integer
                          }
                          disabled={disableFields}
                        />
                        <label
                          htmlFor="1tpa_type2"
                          className="form-check-label _avPointer"
                        >
                          Not Required
                        </label>{" "}
                        &nbsp;
                      </div>
                    </div>
                    <div className="___tpPern_fx mt-3">
                      <p>Expenses Approval</p>
                      <div className="checkBx_lv">
                        <input
                          className="form-check-input _avPointer"
                          id="0expenses_type1"
                          type="radio"
                          name="expenses_approval"
                          value={1} // Set value to 0
                          checked={formValue?.expenses_approval === 1} // Check if value is 0
                          autoComplete="off"
                          onChange={
                            ({ target: { name, value } }) =>
                              handleOnChange(name, parseInt(value, 10)) // Pass 0 as an integer
                          }
                          disabled={disableFields}
                        />
                        <label
                          htmlFor="0expenses_type1"
                          className="form-check-label _avPointer"
                        >
                          Required
                        </label>{" "}
                        &nbsp;
                        <input
                          className="form-check-input _avPointer"
                          id="1expenses_type2"
                          type="radio"
                          name="expenses_approval"
                          value={0} // Set value to 1
                          checked={formValue?.expenses_approval === 0} // Check if value is 1
                          autoComplete="off"
                          onChange={
                            ({ target: { name, value } }) =>
                              handleOnChange(name, parseInt(value, 10)) // Pass 1 as an integer
                          }
                          disabled={disableFields}
                        />
                        <label
                          htmlFor="1expenses_type2"
                          className="form-check-label _avPointer"
                        >
                          Not Required
                        </label>{" "}
                        &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
  
  
                <div className="_addRl_bx">
                <div className="_addRlHead">Contract Permission</div>
  
                 
                </div>
              </div>
            </div>
  
            <div className="bottomFix">
              {disableFields !== true && (
                <button
                  className="_addComm_btn"
                  onClick={(e) => onSubmit(e, "add")}
                  type="button"
                  disabled={
                    disabled ||
                    !selectedBranchIds.length ||
                    !formValue?.company_id ||
                    !formValue?.company_user_name ||
                    !formValue?.role_id ||
                    !formValue?.mobileno ||
                    filterAccountList.length == 0
                  }
                >
                  {id ? "Update User" : "Add User"}
                </button>
              )}
              {!id && (
                <button
                  className="_addComm_btn"
                  onClick={(e) => onSubmit(e, "addSave")}
                  type="button"
                  disabled={
                    disabled ||
                    !selectedBranchIds.length ||
                    !formValue?.company_id ||
                    !formValue?.company_user_name ||
                    !formValue?.role_id ||
                    !formValue?.mobileno ||
                    filterAccountList.length == 0
                  }
                >
                  Add & New
                </button>
              )}
              <button className="_cancel_btn" onClick={() => navigate(-1)}>
                Cancel
              </button>
            </div>
          </div>
        ) : (
            <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
            <Loading />
            </div>
        )}
      </div>
    );
  };
  
  export default AddUserSetting;
  
  export const Checkbox = ({
    id,
    type,
    index,
    name,
    handleClick,
    isChecked,
    className,
    isDisabled,
  }) => {
    return (
      <div className={className}>
        <input
          type="checkbox"
          id={id}
          onChange={handleClick}
          checked={isChecked}
          disabled={isDisabled}
        />
        <label htmlFor={id} className="anvLable">
          {name}
        </label>
      </div>
    );
  };
  
  export const useSelectAll = (state, key, setSelectAll) => {
    useEffect(() => {
      const anyChecked = Object.values(state).some((value) => value === 0);
      setSelectAll((prevSelectAll) => ({
        ...prevSelectAll,
        [key]: anyChecked ? 0 : 1,
      }));
    }, [state, key, setSelectAll]);
  };
  